export default __webpack_public_path__ + "static/media/darkPdfIcon.fac6687f.svg";